import { Breadcrumbs, Link, Stack, Typography } from "@mui/material";
import { useMemo } from "react";

// Components
import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import FormContainer from "../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../common/components/default_form_input";
// Inputs
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";

// ViewModel
import { useAvaliacaoFornecimentoCadastroViewModel } from "../../viewModels/avaliacao_fornecimento_view_model";
import { BackButton } from "../../../../../common/components/back_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import BottomBar from "../../../../../components/global/BottomBar";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { LegendCircularIcon } from "../../../../../common/components/legend_circular_icon";
import { AvaliacaoOrdemCompraItem } from "../../../../compras/domain/models/avaliacao_ordem_compra";
import { CustomStyledDataGrid } from "./components/styled_data_grid";
import { GenerateAvaliacaoFornecedorCadastroColumnDefinition } from "./components/avaliacao_fornecedor_cadastro";
import { isValidId } from "../../../../../common/utils/utils";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

export const AvaliacaoFornecimento = () => {

  const viewModel = useAvaliacaoFornecimentoCadastroViewModel();

  const columnDefinition = useMemo(() => {
    return GenerateAvaliacaoFornecedorCadastroColumnDefinition({
      onNotaChange: viewModel.handleAvaliacaoNotaChange,
    });
  }, [viewModel.handleAvaliacaoNotaChange]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <BackButton
              onClick={viewModel.handleNavigateBack}
            />
          } />
      </PageTopBar>
      <form id="form-avaliacao"
        onSubmit={viewModel.hookForm.handleSubmit(viewModel.handleAvaliacaoSubmit, (e) => console.log(e))}>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Terceirização
            </Link>
            <Typography className="text-primary-green">
              Medição Lista
            </Typography>
            <Typography className="text-primary-green">
              Cadastro de Medição
            </Typography>
            <Typography className="text-primary-green">
              Avaliação de Fornecimento
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Avaliação do Fornecedor</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
            <FormContainer title={"Controle Geral de Avaliação do Fornecedor"} arrangement="fullRow">
              <>
                <div className="flex w-full justify-between mb-6 px-4">
                  <div className="flex flex-col gap-1 text-lg font-bold">
                    <div className="flex gap-2">
                      <span>Fornecedor:</span>
                      <span className="uppercase">{viewModel.hookForm.watch("NomeFornecedor") || "..."}</span>
                    </div>
                    <div className="flex gap-2">
                      <span>Medição:</span>
                      <span>{viewModel.hookForm.watch("NrMedicaoTerceirizacao") || "..."}</span>
                    </div>
                  </div>
                  <div className="flex gap-2 text-lg font-bold">
                    <span>Centro de Custo:</span>
                    <span className="uppercase">{viewModel.hookForm.watch("NomeCentroCusto") || "..."}</span>
                  </div>
                </div>
                <hr className="w-full border-gray-300 mb-6" />
                <div className="flex flex-col w-full gap-6 px-4">
                  <div className="flex flex-row w-full justify-between gap-10">
                    <div className="flex items-center gap-4 w-1/2">
                      <FormRadioGroupInput
                        name="Entregue"
                        label="Serviço Entregue"
                        readOnly={viewModel.saving}
                        options={[
                          { id: 1, label: "Sim" },
                          { id: 0, label: "Não" },
                        ]}
                        required={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="flex items-center gap-4 w-1/2">
                      <FormRadioGroupInput
                        name="NroNotaFiscalEntregue"
                        label="NF Entregue"
                        readOnly={viewModel.saving}
                        options={[
                          { id: 1, label: "Sim" },
                          { id: 0, label: "Não" },
                          { id: 2, label: "Não se Aplica" },
                        ]}
                        required={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>
                  <div className="flex flex-row w-full justify-between gap-10">
                    <div className="w-1/4">
                      <FormDatePickerInput
                        name='Data'
                        label='Data'
                        required={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                    <div className="w-1/2"></div>
                  </div>

                  <div className="flex flex-row w-full justify-between gap-10">
                    <div className="w-1/2">
                      <DropDownFuncionario
                        name="IdFuncionarioAvaliador"
                        label="Avaliado Por"
                        readOnly={viewModel.saving}
                        required={true}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>

                    <div className="w-1/2">
                      <DefaultFormInput
                        name='NroNotaFiscal'
                        label="Nro Nota Fiscal"
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>

                </div>
                <div className="w-full flex flex-col gap-2 p-4 bg-light-mode-2 dark:bg-dark-mode-2 rounded border border-border-light-mode dark:border-border-dark-mode text-black dark:text-white">
                  <div className="flex flex-row items-center gap-2 border-b border-border-light-mode dark:border-border-dark-mode">
                    <h1 className="text-xl text-black dark:text-white font-normal">
                      Critérios de Avaliação
                    </h1>
                  </div>

                  <div className="w-full flex flex-col gap-2">
                    <Stack>
                      <div className="w-full flex flex-row justify-between mt-4">
                        <div className="flex flex-col flex-wrap justify-end">
                          <LegendComponent>
                            <LegendItemComponent
                              icon={<LegendCircularIcon color='green' title='1' />}
                              label='Não Atendeu'
                            />

                            <LegendItemComponent
                              icon={<LegendCircularIcon color='yellow' title='2' />}
                              label='Atendeu Parcialmente'
                            />

                            <LegendItemComponent
                              icon={<LegendCircularIcon color='red' title='3' />}
                              label='Atendeu Plenamente'
                            />
                          </LegendComponent>
                        </div>

                        <div className="flex flex-row gap-4 text-black dark:text-white">
                          <span>NOTA MÉDIA:</span>
                          <span className="font-bold">
                            {
                              viewModel.notaMedia !== 0
                                ? viewModel.notaMedia.toFixed(2).replaceAll('.', ',')
                                : "0,00"
                            }
                          </span>
                        </div>
                      </div>

                      <CustomStyledDataGrid
                        tableName="avaliacafornecimento"
                        disableRowSelectionOnClick={true}
                        disableColumnMenu={false}
                        getRowId={(row: AvaliacaoOrdemCompraItem) => row.idCriterioAvaliacaoFornecedor}
                        columns={columnDefinition}
                        loading={viewModel.loading || viewModel.saving}
                        rows={viewModel.criterioItems}
                        disableColumnSorting={true}
                        disableColumnResize={true}
                        showToolbar={false}
                        sortModel={[{ field: 'ordem', sort: 'asc' }]}
                      />

                      <div className="w-full flex flex-row justify-between">
                        <div>
                          {viewModel.hookForm.formState.errors.root &&
                            <span className="text-red-500 text-sm">
                              {viewModel.hookForm.formState.errors.root.message}
                            </span>
                          }
                        </div>
                      </div>
                    </Stack>

                    <div className="w-full flex flex-col gap-1 mt-4 justify-center">
                      <div className="flex flow-row gap-2">
                        <span className="text-black dark:text-white font-bold">
                          Observações
                        </span>
                        <span className="text-red-500 text-sm mt-[0.15rem]">
                          (Em caso de nota 1 ou 2, inserir o motivo da nota e qual será a tratativa.)
                        </span>
                      </div>

                      <DefaultFormInput
                        name='Observacao'
                        label=''
                        multiline={true}
                        rows={7}
                        reactHookForm={viewModel.hookForm}
                      />
                    </div>
                  </div>
                </div>
              </>
            </FormContainer>

          </div>
        </div>
        <BottomBar>
          <div className="w-full h-full items-center justify-between flex p-4 gap-4">
            <div>
              {
                isValidId(viewModel.idMedicaoTerceirizacao) &&
                <PrimaryButton
                  buttonColor="yellow"
                  onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                  <span className="text-xs">
                    Historico de alterações
                  </span>
                </PrimaryButton>
              }
            </div>
            <div className="flex flex-row gap-4">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={viewModel.handleNavigateBack}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[130px]">
                {viewModel.saving
                  ? (
                    <PrimaryButton>
                      Salvando...
                    </PrimaryButton>
                  ) : (
                    <PrimaryButton
                      type="submit"
                      form="form-avaliacao"
                      startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                      Salvar
                    </PrimaryButton>
                  )}
              </div>
            </div>
          </div>
        </BottomBar>
      </form>
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
    </>
  );
}